import { BROWSER_EXTENSION_ORIGINS } from '../constants/extensionOrigin';
import { PostMessageType } from '../schema/PostMessageType';
import { isOpx } from 'owa-opx/lib/isOpx';

export default function postMessageToParentExtension(message: PostMessageType) {
    if (isOpx()) {
        BROWSER_EXTENSION_ORIGINS.forEach(origin => window.parent.postMessage(message, origin));
    }
}
